/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.warning\":[\"Varoituskolmio, jonka sisällä on huutomerkki\"]}");